import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    heading: {
      fontSize: { '2xl': '4.5rem', lg: '4rem', md: '2.5rem', base: '2.5rem' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      lineHeight: { base: '44px', md: '64px' },
      color: '#FFF',
      fontFamily: 'Trirong',
      fontStyle: 'italic',
      fontWeight: 500,
      letterSpacing: { base: '-1.6px', md: '-1.44px' },
    },
    markText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '40px', base: '26px' },
      lineHeight: { base: '28px', md: '44px' },
      color: '#fff',
      fontWeight: 500,
      fontStyle: 'normal',
      letterSpacing: '-0.44px',
    },
    des: {
      fontSize: { lg: '20px', md: '18px', base: '16px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: { lg: '30px', md: '24px', base: '24px' },
      color: '#FFF',
      fontStyle: 'normal',
      fontWeight: 400,
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const TopBannerV2St = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ 
    lang: 'te',
    markText: {
      lineHeight: { base: '28px', md: '64px' },
    },
  }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({ lang: 'ta' }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default TopBannerV2St;
